function formatFileSize(bytes) {
  if (bytes === 0) return "0 Bytes";

  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));

  return `${(bytes / Math.pow(1024, i)).toFixed(2)} ${sizes[i]}`;
}

export function calcularTamanhoArquivoBase64(base64) {
  const base64SemCabecalho = base64.replace(/^data:.+;base64,/, '');

  const tamanhoBase64 = base64SemCabecalho.length;

  const tamanhoOriginalBytes = (tamanhoBase64 * 3) / 4 - (base64SemCabecalho.endsWith('==') ? 2 : base64SemCabecalho.endsWith('=') ? 1 : 0);
  const tamanho_format = formatFileSize(tamanhoOriginalBytes)
  return tamanho_format
}